import { useQuery } from "@tanstack/react-query";
import { projectKeys } from "@/lib/query";

export interface Project {
  id: string;
  name: string;
  accountName: string | null;
  isBillable: boolean;
  isActive: boolean;
  projectLead: string | null;
  demand: string | null;
  demandEndDate: string | null;
  product: string | null;
  countTotal: number;
  totalComplete: number;
  complianceRate: number | null;
  solutionArchitect: string | null;
  csm: string | null;
}

async function fetchProjects(): Promise<Project[]> {
  const res = await fetch("/api/projects");
  if (!res.ok) throw new Error(`Failed to load projects: ${res.status}`);
  const { projects } = (await res.json()) as { projects: Project[] };
  return projects;
}

export function useAllProjects() {
  return useQuery({
    queryKey: projectKeys.all,
    queryFn: fetchProjects,
    staleTime: 5 * 60_000,
  });
}

export function useProject(id: string) {
  const query = useAllProjects();
  return {
    ...query,
    data: query.data?.find((p) => p.id === id),
  };
}
